import styled from 'styled-components'
import {FaTimes} from 'react-icons/fa'
import {Link as LinkR} from 'react-router-dom'
import {Link as LinkS} from 'react-scroll'
export const SidebarContainer = styled.aside`
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: #0d0d0d;
    display: grid;
    align-items: center;
    top: 0;
    left: 0;
    transition: all 0.3s ease-in-out;
    opacity: ${({isOpen}) => (isOpen ? '100%' : '0')};
    top: ${({isOpen})=>(isOpen ? '0' : '-100%')};
`
export const CloseIcon = styled(FaTimes)`
    color : white;
`
export const Icon = styled.div`
    position: absolute;
    top: 1.2rem;
    right:1.5rem;
    background: transparent;
    font-size: 2rem;
    cursor : pointer;
    outline: none;
`
export const SidebarWrapper = styled.div`
    color: white;
`
export const SidebarLink = styled(LinkR)`
    display: flex;
    padding: 100px;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    cursor : pointer;
    text-decoration: none;
    list-style: none;
    transition: all 0.2s ease-in-out;
    color: white;
    &:hover{
        color:#01bf71;
        transition: all 0.2s ease-in-out;
    }
`
export const SideBtnWrap = styled.div`
    display: flex;
    justify-content:center;
`
export const SidebarMenu = styled.ul`
    display: grid;
    grid-template-columns: 2fr;
    grid-template-rows: repeat(4,100px);
    text-align: center;
    @media screen and (max-width:768px){
        grid-template-rows: repeat(4,80px);
    }
`
export const SidebarRoute = styled(LinkR)`
   border-radius: 50px;
    background: #01bf71;
    white-space: nowrap;
    padding: 10px 22px;
    color:#010606;
    font-size: 16px;
    outline:none;
    border:none;
    cursor : pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    &:hover{
        transition: all 0.2s ease-in-out;
        background: white;
        color:#010606;
    }
`